// PDF.js setup - run this once at app startup
import { pdfjs } from 'react-pdf';

if (typeof window !== 'undefined') {
  try {
    // Set worker source for better compatibility
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
    
    // Alternative worker setup for better error handling
    if (window.Worker) {
      pdfjs.GlobalWorkerOptions.workerPort = new Worker(
        new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url),
        { type: 'module' }
      );
    }
  } catch (error) {
    console.warn('PDF.js worker setup failed:', error);
    // Fallback to CDN worker
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
  }
}
